import { CheckboxField, FormLayout, InputField, ImageField, RadioEnumField, VideoField } from '@app/lib/form'
import { SelectLinkField } from '@app/lib/plugins/link/select-link-field'
import { BlockEditorField } from '@app/lib/plugins/rich-text/editor'
import { Component, HasOne } from '@contember/interface'
import { RichText } from '../rich-text'
import { LocaleSideDimension } from '../locale-side-dimension'
import { OptionalVideoInput } from '../atoms/optional-video-input'

export interface HeroFormProps {
	over?: 'hero' | 'heroes' | 'heroText' | 'heroImage' | (string & {})
	withSubtitle?: boolean
}

export const HeroForm = Component<HeroFormProps>(({ withSubtitle }) => (
	<FormLayout>
		<div className="grid gap-4 md:grid-cols-2">
			<div className="flex flex-col gap-4">
				<RadioEnumField field="heroType" label="Type" defaultValue="withIcon" options={{ withImage: 'withImage', withIcon: 'withIcon' }} />
				<InputField field="topIdentifier" label="Top identifier" />
				<CheckboxField field="hasSolidBackground" label="Has solid background" defaultValue={false} />
			</div>
			<ImageField
				label="Image"
				baseField="image"
				urlField="url"
				widthField="width"
				heightField="height"
				fileNameField="meta.fileName"
				fileTypeField="meta.fileType"
				fileSizeField="meta.fileSize"
				lastModifiedField="meta.lastModified"
			/>
			<OptionalVideoInput videoField="video" />
		</div>
		<LocaleSideDimension>
			<RichText field="title" label="Title (visible on page hero)" />
			{withSubtitle && <RichText field="subtitle" label="Subtitle" />}
			<InputField field="leadText" label="Quote" />
			<InputField field="description" label="Description" />

			<br />
			<InputField field="primaryLinkLabel" label="Primary link label" />
			<SelectLinkField field="primaryLink" label="Primary link" />
			<br />
			<InputField field="secondaryLinkLabel" label="Secondary link label" />
			<SelectLinkField field="secondaryLink" label="Secondary link" />
		</LocaleSideDimension>
	</FormLayout>
))
